import { memo } from "react";

import { type RFNode } from "../../types";
import { getNodeTitle } from "../utils/nodeUtils";
import { SourceHandle, TargetHandle } from "./Handle";
import { RoundedNodeIcon } from "./NodeIcon";
import NodeWrapper from "./NodeWrapper";

type Props = {
  id: string;
  data: RFNode;
  selected?: boolean;
};

const InternalConditionNode = ({ id, data, selected }: Props) => (
  <>
    <NodeWrapper
      title={getNodeTitle(data)}
      name={`${data.stepNumber}. ${data.nodeData.name || "IF statement"}`}
      status={data.nodeData.status || "validated"}
      onEdit={data.onEditNode}
      onDelete={data.onDeleteNode}
      isActive={!!selected}
      icon={<RoundedNodeIcon node={data} />}
    />
    <SourceHandle id={id} idSuffix="true" style={{ left: "45%" }} />
    <SourceHandle id={id} idSuffix="false" style={{ left: "55%" }} />
    <TargetHandle id={id} />
  </>
);

export const ConditionNode = memo(InternalConditionNode);
